import { ENVIAR_IMAGENES, ENVIAR_PRODUCTOS_HOME } from "../constants";
import Axios from "../extras/Axios";

export async function submitImagenes(formData) {
    const respuesta = await Axios.post(ENVIAR_IMAGENES, formData, {
        Headers: { "Content-Type": "multipart/form-data" },
        validateStatus: (status) => status < 500
    });
    if (respuesta.status === 200) return true;
    return false
}

export async function getImages() {
    const respuesta = await Axios.get(ENVIAR_IMAGENES);
    if (respuesta.status === 200) return respuesta.data;
}

export async function modificarImagenes(images) {
    await Axios.put(ENVIAR_IMAGENES, images);
}

export async function modificarProductosHome(codigos) {
    await Axios.post(ENVIAR_PRODUCTOS_HOME, codigos);
}
export async function getProductosHome() {
    return (await Axios.get(ENVIAR_PRODUCTOS_HOME)).data;
}